import { useCallback, useState } from 'react';
import AuthLayout from '@/components/common/AuthLayout';
import ForgotPasswordForm from '@/components/auth/ForgotPasswordForm';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@/app/hooks';
import { forgotPassword } from '@/features/auth/authThunks';

export default function ForgotPasswordPage() {
  const { t } = useTranslation('auth');
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useAppDispatch();

  const handleSubmit = useCallback(
    async (data: { email: string }) => {
      setFormError(null);
      setLoading(true);

      const result = await dispatch(forgotPassword({ email: data.email }));
      if (forgotPassword.fulfilled.match(result)) {
        setSuccess(true);
      } else if (forgotPassword.rejected.match(result)) {
        const messageKey = result.payload?.message ?? 'errors.generic';
        setFormError(t(messageKey));
      }
      setLoading(false);
    },
    [dispatch, t],
  );

  const title = success ? t('forgotPasswordSuccessTitle') : t('forgotPasswordTitle');

  return (
    <AuthLayout title={title} background="gradient" returnIcon={true} success={success}>
      <ForgotPasswordForm
        onSubmit={handleSubmit}
        loading={loading}
        formError={formError}
        success={success}
      />
    </AuthLayout>
  );
}
